import React, { useState, useEffect } from 'react';
import { Button, Card, Form, Input, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import './index.css';
import { useSelector, useDispatch } from 'react-redux'
import { type RootState, type AppDispatch, store } from '../../store/index'
import { setUserState, clearTokens } from '../../store/user/userInfo'
import { setUserMenu, setCurrentMenu, clearMenu } from '../../store/user/userMenu'
import { login, ApiResponse } from '../../api/api-login'
import { useCookie } from '@/utils/util'
import { getAllMenu, getRoleMenu } from "@/api/api-menu-list"
import { getToken } from '@/utils/util';
import { deleteExpiredData, deleteData } from '@/utils/dataBase';
import loginLogo from '@/assets/file.svg';
const Login: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>()
  const { value: token, setValue: setToken, remove: removeToken } = useCookie('token');

  const isLoggedIn = useSelector((state: any) => {
    return !!(getToken('token') || localStorage.getItem('token')) && localStorage.getItem('tokenExpire')
  });
  useEffect(() => {
    console.log(isLoggedIn, 111);
    if (isLoggedIn) {
      navigate('/'); // 登录后跳首页
    } else {
      // 以防有遗留的数据，先做缓存清除（Redux + 持久化 + cookie）
      // dispatch(clearTokens())          // 清空用户 token
      // dispatch(clearMenu())           // 清空菜单相关状态
      // removeToken()                   // 清除 cookie 中的 token
      // try {
      //   // 清除 redux-persist 在 localStorage 里的缓存，避免刷新后又恢复旧状态
      //   localStorage.removeItem('persist:root')
      //   localStorage.removeItem('tokenExpire')
      // } catch (e) {
      //   console.warn('清除持久化状态失败', e)
      // }
    }
    const midnight = new Date().setHours(0, 0, 0, 0);
    const threeDaysAgo = Date.now() - 3 * 24 * 60 * 60 * 1000;
    deleteExpiredData(midnight, 'tao-check-detail')
    deleteExpiredData(midnight, 'tao-checked-detail')
    deleteExpiredData(midnight, 'jd-check-detail')
    deleteExpiredData(midnight, 'jd-checked-detail')
    deleteExpiredData(midnight, 'pdd-check-detail')
    deleteExpiredData(midnight, 'pdd-checked-detail')
    deleteExpiredData(midnight, 'kuaishou-user-check-data')
    deleteExpiredData(midnight, 'kuaishou-user-checked-data')
    deleteExpiredData(midnight, 'kuaishou-video-check-data')
    deleteExpiredData(midnight, 'kuaishou-video-checked-data')
    deleteExpiredData(midnight, 'kuaishou-profile-check-data')
    deleteExpiredData(midnight, 'kuaishou-profile-checked-data')
    deleteExpiredData(midnight, 'ks-shop-check-list')
    deleteExpiredData(midnight, 'ks-shop-checked-list')
    deleteExpiredData(midnight, 'weixin-check-detail')
    deleteExpiredData(midnight, 'weixin-checked-detail')
    deleteExpiredData(midnight, 'jd-keyword-data-list')
    deleteExpiredData(midnight, 'tao-keyword-data-list')
    deleteExpiredData(midnight, 'tao-shop-data-list')
    deleteExpiredData(midnight, 'tao-detail-data')
    deleteExpiredData(midnight, 'jd-detail-data')
    deleteExpiredData(threeDaysAgo, 'tao-html-detail-data')
    deleteData('wx-receive-count')
    deleteData('ks-video-receive-count')
    deleteData('ks-live-receive-countt')
    deleteData('ks-receive-count')
    deleteData('ks-shop-receive-count')
    deleteData('ks-user-receive-count')
    deleteData('jd-receive-count')
    deleteData('pdd-receive-count')
    deleteData('tao-receive-count')
    deleteData('tao-shop-receive-count')
    deleteData('tao-keyword-receive-count')
    deleteData('jd-keyword-receive-count')
    deleteData('tao-detail-receive-count')
  }, [isLoggedIn]);
  const [messageApi, contextHolder] = message.useMessage();
  const onFinish = (values: any) => {
    login({ userName: values.username, password: values.password }).then((res: ApiResponse) => {
      if (res?.status?.code === '0') {
        dispatch(setUserState({ accessToken: res.result.accessToken, authorization: res.result.authorization, roleCode: res.result.roles[0], username: res.result.userName }))
        localStorage.setItem('tokenExpire', res.result.expiresAt)
        setToken(res.result.accessToken)
        //请求角色菜单
        getRoleMenu(res.result.userId).then(res => {
          console.log(res.result, '角色菜单');
          dispatch(setUserMenu(res.result))
        })
        //请求所有菜单
        getAllMenu().then(res => {
          console.log(res);

        })

      } else {
        messageApi.open({
          type: 'error',
          content: res.status.message,
        });
      }
    })
  };
  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <div className='login-fullscreen'>
      {contextHolder}
      <video
        className='login-bg'
        autoPlay
        muted
        loop
        playsInline
        preload="none"
        poster="/login-poster.png"
      >
        <source src="/login-bg.webm" type="video/webm" />
      </video>
      {/* <div className='login-overlay' /> */}
      <Card className='login-card'>
        <div className='login-logo-wrap'>
          <img src={loginLogo} width={80} height={80} alt="logo" className='login-logo' />
        </div>
        <h2 className='login-title'>用户登录</h2>
        <Form
          name="basic"
          labelCol={{ flex: '70px' }}
          wrapperCol={{ flex: 1 }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          className='login-form'
        >
          <Form.Item
            label="用户名"
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="密码"
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password />
          </Form.Item>

          <Form.Item className='login-submit-item'>
            <Button color="default" variant="solid" htmlType="submit" block>
              登录
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;